var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 158,
    viewBox: "0 0 129 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_252_3306)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.9 146.257C101.9 142.221 98.6301 138.951 94.5959 138.951H31.6068C27.5724 138.951 24.3022 142.221 24.3022 146.257C24.3022 150.291 27.5724 153.562 31.6068 153.562H94.5959C98.6301 153.562 101.9 150.291 101.9 146.257Z",
    fill: "#8FA3BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6895 118.415H96.5142V147.031H29.6895V118.415Z",
    fill: "#0A2445"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5259 123.737H82.6772V141.27H43.5259V123.737Z",
    fill: "#FEEDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0867 138.476H79.116V126.254H47.0867V138.476ZM79.6801 139.605H46.5226C46.2111 139.605 45.9585 139.351 45.9585 139.04V125.69C45.9585 125.379 46.2111 125.126 46.5226 125.126H79.6801C79.9916 125.126 80.2442 125.379 80.2442 125.69V139.04C80.2442 139.351 79.9916 139.605 79.6801 139.605Z",
    fill: "#FBCB22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6897 114.798C29.8978 108.88 48.8564 107.636 63.1 98.0854C77.4343 108.854 96.3035 108.894 96.511 114.798H96.5126V118.391H29.688V114.798H29.6897Z",
    fill: "#FBCB22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4938 115.406H34.7072C34.455 115.406 34.2505 115.202 34.2505 114.95C34.2505 114.697 34.455 114.493 34.7072 114.493H91.4938C91.7462 114.493 91.9507 114.697 91.9507 114.95C91.9507 115.202 91.7462 115.406 91.4938 115.406Z",
    fill: "#ECA400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4785 79.6924C54.4785 79.6924 56.3885 82.5526 57.9773 87.6095C58.4963 89.2628 59.0246 91.0148 59.0067 92.8879C58.9883 94.7757 58.3998 96.5018 57.8699 98.1659C56.2765 103.167 54.4785 106.083 54.4785 106.083C54.4785 110.842 71.7224 110.842 71.7224 106.083C71.7224 106.083 69.925 103.167 68.3317 98.1659C67.8012 96.5018 67.2132 94.7757 67.1947 92.8879C67.1763 91.0148 67.7051 89.2628 68.2243 87.6095C69.813 82.5526 71.7224 79.6924 71.7224 79.6924C71.7224 74.9334 67.8593 71.0703 63.1005 71.0703C58.3422 71.0703 54.4785 74.9334 54.4785 79.6924Z",
    fill: "#ECA400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.182 59.8594C20.2501 59.8594 14.5262 58.6039 9.89451 55.0079C4.24998 50.6253 1.25821 43.7989 1.00195 34.7181C0.784295 27.004 2.8418 21.5141 7.11753 18.4012C13.7506 13.5713 22.9495 16.7473 23.3378 16.8848C24.83 17.4142 25.6114 19.0518 25.0826 20.5439C24.555 22.0339 22.9214 22.8149 21.4316 22.2916C21.333 22.2578 14.6386 19.9968 10.4743 23.0484C7.8305 24.9861 6.57157 28.8578 6.73266 34.5564C6.93809 41.8415 9.18478 47.1988 13.4103 50.4795C18.4588 54.3992 25.3412 54.6396 29.7012 53.6547C31.245 53.3054 32.7799 54.2748 33.1288 55.8191C33.4778 57.3631 32.5087 58.8978 30.9645 59.2467C29.2852 59.626 27.3066 59.8592 25.182 59.8594Z",
    fill: "#ECA400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79 59.8594C98.6652 59.8594 96.6876 59.6262 95.0079 59.2467C93.4637 58.8978 92.4946 57.3631 92.8436 55.8191C93.1925 54.2748 94.727 53.3064 96.2712 53.6547C100.631 54.64 107.513 54.3992 112.562 50.4797C116.788 47.1988 119.034 41.8415 119.24 34.5566C119.401 28.8578 118.142 24.9861 115.498 23.0484C111.324 19.9896 104.608 22.2685 104.54 22.2918C103.048 22.8097 101.414 22.0245 100.891 20.534C100.368 19.0434 101.145 17.4123 102.634 16.8848C103.023 16.7473 112.222 13.5713 118.855 18.4012C123.131 21.5141 125.188 27.004 124.97 34.7183C124.714 43.7989 121.722 50.6253 116.078 55.0079C111.447 58.6035 105.722 59.8592 100.79 59.8594Z",
    fill: "#ECA400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8755 20.6387V9.10063C19.8755 4.35004 23.7255 0.501411 28.4745 0.501411H97.4967C99.7768 0.501411 101.965 1.40719 103.577 3.02002C105.19 4.63286 106.096 6.81897 106.096 9.10063C106.096 14.6519 106.096 20.8443 106.096 20.8443C106.019 55.8175 86.7312 84.1719 62.9855 84.1719C39.1928 84.1719 19.8755 55.7039 19.8755 20.6387Z",
    fill: "#FBCB22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8673 20.3053C75.0348 20.3053 84.8985 30.169 84.8985 42.3364C84.8985 54.5037 75.0348 64.3672 62.8673 64.3672C50.7001 64.3672 40.8364 54.5037 40.8364 42.3364C40.8364 30.169 50.7001 20.3053 62.8673 20.3053Z",
    fill: "#FEEDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8677 17.7887C49.3327 17.7887 38.3211 28.8003 38.3211 42.3352C38.3211 55.8702 49.3327 66.8818 62.8677 66.8818C76.4029 66.8818 87.4145 55.8702 87.4145 42.3352C87.4145 28.8003 76.4029 17.7887 62.8677 17.7887ZM62.8677 68.0312C48.6988 68.0312 37.1719 56.5041 37.1719 42.3352C37.1719 28.1664 48.6988 16.64 62.8677 16.64C77.0365 16.64 88.5637 28.1664 88.5637 42.3352C88.5637 56.5041 77.0365 68.0312 62.8677 68.0312Z",
    fill: "#ECA400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0493 30.3899C62.1647 30.0356 62.4942 29.7961 62.8668 29.7961C63.2394 29.7961 63.5698 30.0356 63.6851 30.3899C64.5286 32.9864 65.7863 36.8582 66.2641 38.3268C66.3787 38.6816 66.7089 38.9211 67.0818 38.9211C68.6262 38.9211 72.6969 38.9211 75.4266 38.9211C75.7993 38.9211 76.1297 39.1613 76.2449 39.5155C76.3603 39.8696 76.234 40.2581 75.9325 40.4771C73.724 42.0816 70.4305 44.4742 69.1809 45.3819C68.8792 45.6009 68.7536 45.9892 68.8683 46.3435C69.346 47.8129 70.6038 51.6836 71.4473 54.2802C71.5625 54.6345 71.4364 55.0228 71.1349 55.242C70.8337 55.461 70.4257 55.461 70.124 55.242C67.9157 53.6368 64.6222 51.2441 63.3726 50.3364C63.0709 50.1175 62.6629 50.1175 62.3617 50.3364C61.1124 51.2441 57.8187 53.6368 55.6104 55.242C55.3087 55.461 54.9007 55.461 54.5989 55.242C54.298 55.0228 54.1718 54.6345 54.2871 54.2802C55.1306 51.6836 56.3883 47.8129 56.8655 46.3435C56.9807 45.9892 56.8546 45.6009 56.5534 45.3819C55.3039 44.4742 52.0104 42.0816 49.8021 40.4771C49.5004 40.2581 49.3742 39.8696 49.4895 39.5155C49.6049 39.1613 49.9345 38.9211 50.307 38.9211C53.0375 38.9211 57.1076 38.9211 58.6528 38.9211C59.0252 38.9211 59.3551 38.6816 59.4703 38.3268C59.948 36.8582 61.2058 32.9864 62.0493 30.3899Z",
    fill: "#FBCB22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0924 53.3438C32.4217 53.3438 31.7838 52.9497 31.5048 52.2933C23.9818 34.5934 24.7661 17.8263 24.8032 17.1213C24.853 16.1697 25.6654 15.4378 26.6157 15.4894C27.5668 15.5391 28.2971 16.3512 28.2471 17.3029C28.2363 17.519 27.4915 34.0339 34.6787 50.9444C35.0513 51.8207 34.6428 52.8333 33.7662 53.2058C33.5461 53.2994 33.3175 53.3438 33.0924 53.3438Z",
    fill: "#FEEDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8383 66.9766C40.311 66.9766 39.7909 66.7358 39.4524 66.2802C37.6531 63.8577 35.9868 61.242 34.4997 58.5057C34.0449 57.6689 34.3546 56.6221 35.1914 56.1673C36.028 55.7127 37.0752 56.0221 37.53 56.8591C38.9397 59.4534 40.518 61.9311 42.221 64.2237C42.7889 64.9882 42.6296 66.0685 41.865 66.6362C41.556 66.8659 41.1956 66.9766 40.8383 66.9766Z",
    fill: "#FEEDB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.879 5.2434C108.879 2.62542 106.757 0.502373 104.137 0.502373C88.3122 0.502373 37.4241 0.502373 21.5986 0.502373C18.9797 0.502373 16.8564 2.62542 16.8564 5.2434C16.8564 5.24532 16.8564 5.24533 16.8564 5.24533C16.8564 7.86522 18.9797 9.98828 21.5986 9.98828C37.4241 9.98828 88.3122 9.98828 104.137 9.98828C106.757 9.98828 108.879 7.86522 108.879 5.24533C108.879 5.24533 108.879 5.24532 108.879 5.2434Z",
    fill: "#FEEDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.705 6.07031H24.4979C24.0419 6.07031 23.6724 5.69959 23.6724 5.24478C23.6724 4.78807 24.0419 4.41925 24.4979 4.41925H101.705C102.161 4.41925 102.53 4.78807 102.53 5.24478C102.53 5.69959 102.161 6.07031 101.705 6.07031Z",
    fill: "#FBCB22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6139 30.382L75.6252 23.7546L72.6139 17.1273L79.2412 20.1386L85.8685 17.1273L82.8572 23.7546L85.8685 30.382L79.2412 27.3707L72.6139 30.382Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_252_3306",
    x: 0.986328,
    y: 0.5,
    width: 128,
    height: 157.062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_252_3306"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_252_3306",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.f7482e0bfbfefd24ed4f57673b107914.svg";
export { ForwardRef as ReactComponent };